<h1 mat-dialog-title>Attenzione</h1>
<div mat-dialog-content>

  Per proseguire con questo pagamento deve essere prima saldato e verificato l'addebito della rata precedente.

</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-button mat-dialog-close cdkFocusInitial color='warn'>Chiudi</button>
</div>
